import isNil from "lodash/isNil";
import { getOriginalResource } from "PFApp/booking/parts/helpers";
import { getProfilesLinkedToEngagementAndNestedRolesRequest } from "PFApp/booking/parts/overview/side_panel_row/get_request_data/get_profiles_linked_to_engagements_and_nested_roles_request";
import { RowChildrenResponse } from "PFApp/booking/store";
import { Row } from "PFApp/booking/types";
import { BookingsVisibility } from "PFApp/booking/types/bookings_visibility";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { ProjectItemResource } from "PFApp/booking/types/row";
import { isProjects, isWorkforceProfiles } from "PFApp/booking/utils/calendar_root.utils";
import { BookingCategory, CalendarRange, Filters, Value } from "PFTypes";
import { FiltersV2 } from "PFTypes/filters_v2";

import { getEngagementChildRolesRequest } from "./get_engagement_child_roles_request";
import { getProfileRolesRequest } from "./get_profile_roles_request";
import { getProfilesLinkedToEngagementRequest } from "./get_profiles_linked_to_engagements_request";
import { getRoleProfilesRequest } from "./get_role_profiles_request";

export const PER_PAGE = 50;

export type ChildrenType = "activity" | "role" | "profile";

export type RequestData = {
  url: string;
  params?: { perPage: number; filters?: Filters<Value> } & Record<string, any>;
  data?: { perPage: number; filters?: Filters<Value> } & Record<string, any>;
  options?: Record<string, any>;
  childrenType: ChildrenType;
  mapResponse?: (response: RowChildrenResponse) => Promise<RowChildrenResponse>;
};

type GetRequestsData = {
  calendarRoot: CalendarRoot;
  row: Row;
  dateRange: CalendarRange;
  childrenFilters?: FiltersV2;
  bookingCategories: BookingCategory[];
  isRoleLevelHiddenForEngagementsRoot: boolean;
  bookingsVisibility: BookingsVisibility | null;
};

export const getRequestsData = ({
  calendarRoot,
  row,
  dateRange,
  childrenFilters,
  bookingCategories,
  isRoleLevelHiddenForEngagementsRoot,
  bookingsVisibility
}: GetRequestsData): RequestData[] => {
  const { type } = row;
  const original = getOriginalResource(row, calendarRoot);
  const id = original?.id;
  if (isNil(id)) {
    return [];
  }
  switch (type) {
    case "engagement": {
      if (isRoleLevelHiddenForEngagementsRoot) {
        return [getProfilesLinkedToEngagementAndNestedRolesRequest(id, dateRange, childrenFilters)];
      }
      const { childrenWorkflowStatesTally: childrenStatesTally } = original as ProjectItemResource;
      return [
        ...(childrenStatesTally ? [getEngagementChildRolesRequest(id, childrenFilters)] : []),
        getProfilesLinkedToEngagementRequest(id, dateRange)
      ];
    }
    case "role":
      return isProjects(calendarRoot) ? [getRoleProfilesRequest(id, dateRange)] : [];
    case "profile":
      return isWorkforceProfiles(calendarRoot)
        ? [getProfileRolesRequest(id, dateRange, bookingCategories, bookingsVisibility)]
        : [];
    default:
      return [];
  }
};
